<div
  [ngClass]="{
    'bg-red-50  border-red-200': isMissing,
    'bg-blue-50  border-blue-200': !isMissing,
  }"
  class="rounded-lg p-6 shadow-sm border"
>
  <div class="flex mb-4">
    <div class="flex flex-col"></div>
    <h2 class="text-lg font-semibold">
      <span [innerHTML]="questionHtml | safeHtml"></span>
    </h2>
  </div>
  <div class="mt-4">
    <div class="md:flex justify-between mb-2">
      <img
        *ngIf="question.media_path"
        src="{{ question.media_path }}"
        alt="Question Image"
        class="w-full h-auto object-contain"
      />
    </div>
  </div>
</div>
